var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18002 18.855L5.25002 20.0025C6.17896 20.7926 7.2403 21.4121 8.38502 21.8325L8.90252 20.43C7.9096 20.0689 6.98803 19.5357 6.18002 18.855Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14252 13.5L1.64252 13.8075C1.85642 15.0192 2.28029 16.1842 2.89502 17.25L4.19252 16.5C3.6735 15.5674 3.31835 14.5527 3.14252 13.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86502 3.57L8.34752 2.1675C7.21604 2.59186 6.16768 3.21122 5.25002 3.9975L6.18002 5.145C6.97674 4.46803 7.88533 3.93506 8.86502 3.57Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19252 7.5L2.89502 6.75C2.29198 7.81909 1.87599 8.98333 1.66502 10.1925L3.16502 10.4475C3.33397 9.41284 3.68165 8.41547 4.19252 7.5Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5V3C14.387 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21V22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoading);
export default __webpack_public_path__ + "static/media/ic-loading.2fbb7915a6d606d8a62715ffece4eb04.svg";
export { ForwardRef as ReactComponent };